module.exports = __webpack_public_path__ + "static/img/deal_2.eb7c34fe.png";